var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"backButton",attrs:{"disabled":_vm.disabled},on:{"click":_vm.goBackUrl}},[_vm._v("\n  arrow_back\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }